import { Routes, Route, Navigate } from 'react-router-dom'
import Races from '../../pages/Races/Races'
import Social from '../../pages/Social/Social'
import Groups from '../../pages/Social/Groups'
import Shop from '../../pages/Shop/Shop'
import Terms from '../../pages/Legals/Terms'
import Privacy from '../../pages/Legals/Privacy'
import Cookies from '../../pages/Legals/Cookies'
import EventPage from '../../pages/Events/EventPage'
import RacePage from '../../pages/RaceLayout/RacePage'
import PhotoUpload from '../../pages/Races/PhotoUpload'
import Partners from '../../pages/Others/Partners'
import Sponsors from '../../pages/Others/Sponsors'
import Volunteers from '../../pages/Others/Volunteers'
import About from '../../pages/Others/About'
import Events from '../../pages/Events/Events'
import AdminIndex from '../../pages/Admin/AdminIndex'
import AdminLogin from '../../pages/Admin/AdminLogin'
import AdminLayout from '../../pages/Admin/AdminLayout'
import RequireAdmin from '../../pages/Admin/RequireAdmin'
import RaceList from '../../pages/Admin/RaceList'
import RaceForm from '../../pages/Admin/RaceForm'
import EventList from '../../pages/Admin/EventList'
import EventForm from '../../pages/Admin/EventForm'
import loadable from '@loadable/component'
import NotFound from '../../pages/Legals/404'
const Home = loadable(() => import('pages/Home/Home'))

export default function Main () {
  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/events' element={<Events />} />
      <Route path='/events/:name' element={<EventPage />} />
      <Route path='/races' element={<Races />} />
      <Route path='/races/:name/upload' element={<PhotoUpload />} />
      <Route path='/races/:name/:section/:category/:item' element={<RacePage />} />
      <Route path='/races/:name/:section' element={<RacePage />} />
      <Route path='/races/:name/:section/*' element={<RacePage />} />
      <Route path='/social' element={<Social />} />
      <Route path='/social/groups' element={<Groups />} />
      <Route path='/shop' element={<Shop />} />
      <Route path='/partners' element={<Partners />} />
      <Route path='/sponsors' element={<Sponsors />} />
      <Route path='/volunteers' element={<Volunteers />} />
      <Route path='/about' element={<About />} />

      <Route path='/admin' element={<AdminIndex />} />
      <Route path='/admin/login' element={<AdminLogin />} />
      <Route path='/admin/dashboard' element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
        <Route index element={<Navigate to='/admin/dashboard/races' replace />} />
        <Route path='races' element={<RaceList />} />
        <Route path='races/new' element={<RaceForm />} />
        <Route path='races/:slug/edit' element={<RaceForm />} />
        <Route path='events' element={<EventList />} />
        <Route path='events/new' element={<EventForm />} />
        <Route path='events/:slug/edit' element={<EventForm />} />
      </Route>

      <Route path='/terms' element={<Terms />} />
      <Route path='/privacy' element={<Privacy />} />
      <Route path='/cookies' element={<Cookies />} />
      <Route path='*' element={<NotFound />} />
    </Routes>
  )
}
